import { useCallback } from 'react';
import { Button } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile'

import { VideoUploadDialog } from './VideoUploadDialog';
import { useDialog } from 'main/utils/hooks';


export const UploadButton = () => {
    const { open, hanldeOpen, handleClose } = useDialog();

    const handleClick = useCallback(() => {
        hanldeOpen();
    }, [hanldeOpen]);

    return (
        <>
            <Button variant="contained" startIcon={<UploadFileIcon />} onClick={handleClick}>
                動画アップロード
            </Button>
            <VideoUploadDialog open={open} onClose={handleClose} />
        </>
    )
}
